import React, { useState } from 'react';
import { Loader, Message, Panel, Stack, useToaster } from 'rsuite';
import Lottie from 'react-lottie';
import animationData from '@/images/Locked.json';
import PinInput from 'react-pin-input';
import { verifCode } from '@/services/auth.service';
import { useAppDispatch } from '@/config/hooks';

const PinInputComponent = PinInput as React.FC<PinInputProps>;

const MFAPage = ({ email }) => {
  const toaster = useToaster();

  const [loading, setLoading] = useState(false);

  const dispatch = useAppDispatch();
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  const handleChange = async value => {
    setLoading(true);
    try {
      const result: any = await dispatch(verifCode({ code: value, email: email }));
      // console.log('resultt', result);
      toaster.push(
        <Message closable showIcon type="success" duration={10000}>
          {result.message}
        </Message>,
        {
          placement: 'topCenter'
        }
      );
      if (result.status == 201) {
        setTimeout(() => {
          window.location.pathname = '/';
        }, 5000);
      } else {
        window.location.pathname = '/';
      }
    } catch (error) {
      console.error('Error:', error);
      toaster.push(
        <Message closable showIcon type="error" duration={7000}>
          {error}
        </Message>,
        {
          placement: 'topCenter'
        }
      );
    }
    // dispatch(verifCode({ code: value, email: email }))
    //   .then((response: any) => {
    //     // setLoading(false);
    //     toaster.push(
    //       <Message closable showIcon type="success">
    //         {response?.data?.message}
    //       </Message>,
    //       {
    //         placement: 'topCenter'
    //       }
    //     );
    //   })
    //   .catch(e => {
    //     setLoading(false);
    //     toaster.push(
    //       <Message closable showIcon type="error">
    //         {e.message}
    //       </Message>,
    //       {
    //         placement: 'topCenter'
    //       }
    //     );
    //   });
    // //console.log("reeeeeeeeeeees", result);
  };

  return (
    <div>
      <Stack
        justifyContent="center"
        alignItems="center"
        direction="column"
        style={{
          height: '100vh'
        }}
      >
        <Panel style={{ width: 400 }}>
          <center>
            <Lottie options={defaultOptions} height={250} width={250} />
            <h3 style={{ marginBottom: 10 }}>Code Verification</h3>
            <p className="error-page-subtitle text-muted ">
              Please enter the code sent to your email to proceed with the login
            </p>
          </center>
          <PinInputComponent
            length={6}
            initialValue=""
            // secret
            // onChange={(value, index) => {}}
            type="numeric"
            inputMode="number"
            style={{ padding: '10px' }}
            inputStyle={{ borderColor: 'black' }}
            inputFocusStyle={{ borderColor: 'blue' }}
            onComplete={value => {
              handleChange(value);
            }}
            autoSelect={true}
            regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
            className="pincode-input-text"
          />
          {loading && (
            <center>
              <Loader color="blue" />
            </center>
          )}
        </Panel>
      </Stack>
    </div>
  );
};

export default MFAPage;
